import { useEffect, useState } from 'react'
import 'slick-carousel/slick/slick-theme.css'
import 'slick-carousel/slick/slick.css'
import styled from 'styled-components'
import Page5PcContents from './components/Page5PcContents'
import PopUp2Pc from "../../components/PopUp2Pc";

function Page5Pc(prop) {
  const goods = prop.goods
  const [selectedGoods, setSelectedGoods] = useState()

  useEffect(() => {
    setSelectedGoods(goods[0])
  }, [goods])

  useEffect(() => {}, [selectedGoods])

  const [showPopUpUrl, setShowPopUp] = useState(null);
  const close = () => {
    setShowPopUp(null);
  };
	const [moved, setMoved] = useState(false);
	const downListener = () => {
		setMoved(false);
  }
	const moveListener = () => {
  	setMoved(true);
	}
  const upListener = (url, idx) => {
    console.log(url);
    if (moved) {
        if(url === 'video'){
          debugger
          const video = document.querySelector("#video"+idx);
          video.pause();
          video.currentTime = 0;
        }
    } else {
        if(url !== 'video')
          setShowPopUp(url);
    }
  }

  return (
    <>
    {showPopUpUrl!=null ? <PopUp2Pc img={showPopUpUrl} close={close}/> : null}
    <MainContainer>
      <Top>
        {goods &&
          selectedGoods &&
          goods.map((gs) => {
            return (
              <TopText
                selected={selectedGoods.gsSeq == gs.gsSeq}
                key={gs.gsSeq}
                onClick={() => {
                  setSelectedGoods(gs)
                }}
              >
                {gs.gsName}
              </TopText>
            )
          })}
      </Top>
      {selectedGoods && <Page5PcContents selectedGoods={selectedGoods}  downListener={downListener} moveListener={moveListener} upListener={upListener}/>}
    </MainContainer>
    </>
  )
}

export default Page5Pc
const MainContainer = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: 82px;
  width: 100vw;
  overflow-x: hidden;
  padding-bottom: 102px;
  background: #f8f8f8;
`
const Top = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 44.3px;
  background: #1f1f1b;
  padding: 0px 20px;
  gap: 120px;
`
const TopText = styled.p`
  flex: 0 0 auto;
  font-family: Noto Sans KR;
  font-weight: normal;
  font-size: 13.3px;
  color: ${(props) => (props.selected ? '#A29780' : '#B9B9B9')};
  cursor: pointer;
`
